export default __webpack_public_path__ + "static/media/instruction-img-2.63b44656.png";